module.exports = __webpack_public_path__ + "img/security-audit-img-1.ea5d9ddb.webp";